import { defineStore } from 'pinia';
import { v4 as uuidv4 } from 'uuid';
import { useNetwork } from '@vueuse/core';
import { UAParser } from 'ua-parser-js';

// 模块级建立一次网络监听；若在 getter 内调用 useNetwork()，
// 每次网络变化触发 getter 重求值都会新注册一组事件监听且永不销毁（监听器泄漏）
const networkState = useNetwork();

const useDeviceStore = defineStore('KePuDevice', {
  state: () => ({
    // 初始化即生成设备id，持久化有值时会水合覆盖，保证各处读取不为空
    deviceId: uuidv4(),
    deviceInfo: UAParser(window.navigator.userAgent),
  }),
  getters: {
    network() {
      const { effectiveType, type } = networkState;
      if (type.value === 'wifi') {
        return type.value;
      }
      const result = ['3g', '4g', '5g', '6g'].includes(
        effectiveType.value?.toLowerCase() ?? ''
      )
        ? effectiveType.value || '4g'
        : '4g';
      return result;
    },
    isMobile(state) {
      return state.deviceInfo.device.is('mobile');
    },
  },
  actions: {
    generateDeviceId() {
      this.deviceId = uuidv4();
    },
    /**
     * 获取设备id，为空时自动生成，保证返回值不为空
     * @return {string} 设备id
     */
    getDeviceId() {
      if (!this.deviceId) {
        this.generateDeviceId();
      }
      return this.deviceId;
    },
  },
  persist: {
    serializer: {
      serialize: (state) => JSON.stringify(state),
      deserialize: (data) => {
        try {
          const parsed: unknown = JSON.parse(data);
          if (
            typeof parsed !== 'object' ||
            parsed === null ||
            Array.isArray(parsed)
          ) {
            return {};
          }
          const state = parsed as Record<string, unknown>;
          // 在水合层修复历史遗留/被篡改的空 deviceId，
          // 使所有直接读取 deviceStore.deviceId 的调用点天然拿到非空值
          if (!state.deviceId) {
            state.deviceId = uuidv4();
          }
          return state;
        } catch {
          return {};
        }
      },
    },
  },
});

export default useDeviceStore;
